import { useI18n } from '@hydra/common/customHooks';

interface pricingPageRouteProps {
  queryString?: Array<{[key:string]: string}>
  hash?: string
}

export default function usePricingRoutes () {
  const { locale } = useI18n();
  const basePricingRoute = `/${locale}/p/pricing`;

  const getPricingPageRoute = ({
    queryString,
    hash
  }: pricingPageRouteProps = {}) => {
    const PricingRoute = new URL(basePricingRoute, 'https://www.woorank.com');
    if (hash) { PricingRoute.hash = hash; }
    if (queryString) {
      queryString.map((query) => {
        for (const param in query) {
          PricingRoute.searchParams.append(param, query[param]);
        }
        return null;
      }
      );
    }
    return PricingRoute.toString();
  };
  return {
    getPricingPageRoute
  };
}
